import useEmblaCarousel from "embla-carousel-react";
import {EmblaOptionsType} from "embla-carousel";
import {useEmblaNavigation} from "@/shared/lib/embla/useEmblaNavigation";
import {useEmblaDots} from "@/shared/lib/embla/useEmblaDots";

export const useProductMainCarousel = () => {
    const [mainRef, mainApi] = useEmblaCarousel();

    const thumbsOptions: EmblaOptionsType = {
        axis: 'y',
    }
    const [thumbsRef, thumbsApi] = useEmblaCarousel(thumbsOptions);
    const thumbsNavigation = useEmblaNavigation(thumbsApi);
    const thumbsDots = useEmblaDots(mainApi);

    return {
        mainRef,
        thumbsRef,
        ...thumbsNavigation,
        ...thumbsDots
    };
}
